import { render, staticRenderFns } from "./FFInvitation.vue?vue&type=template&id=0d66b4d2&scoped=true"
import script from "./FFInvitation.vue?vue&type=script&lang=js"
export * from "./FFInvitation.vue?vue&type=script&lang=js"
import style0 from "./FFInvitation.vue?vue&type=style&index=0&id=0d66b4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.6.14_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d66b4d2",
  null
  
)

export default component.exports